<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="6" lg="3">
        <NumberCard title="Top Holder" color="#07D3DA">{{ topHolder | toInt(0, "WISE")}}</NumberCard>
      </v-col>
      <v-col cols="12" md="6" lg="3">
        <NumberCard title="Top Staker" color="#C6362F">{{ topStaker | toInt(0, "WISE")}}</NumberCard>
      </v-col>
      <v-col cols="12" md="6" lg="3">
        <NumberCard title="Top Shares Holder" color="#BDD358">{{ topShareHolder | toInt(0, "Shares")}}</NumberCard>
      </v-col>
      <v-col cols="12" md="6" lg="3">
        <NumberCard title="Top Referrer"  color="#E28413">{{ topReferrer | toInt(0, "rShares")}}</NumberCard>
      </v-col>
    </v-row>

    <v-row class="">
      <v-col cols="12">
        <TopListCard title="Top Holders (Without the Uniswap Account)" totalTitle="Total liquid WISE" :list="topHoldersList" color="#07D3DA" :total="totalLiquid" unit="WISE"/>
      </v-col>
    </v-row>
    <v-row class="">
      <v-col cols="12">
        <TopListCard title="Top Stakers" totalTitle="Total staked WISE" :list="topStakersList" color="#C6362F" :total="totalStaked" unit="WISE"/>
      </v-col>
    </v-row>
    <v-row class="">
      <v-col cols="12">
        <TopListCard title="Top Share Holders" totalTitle="Total wise shares" :list="topShareHoldersList" color="#BDD358" :total="totalShares" unit="SHRS"/>
      </v-col>
    </v-row>
    <v-row class="">
      <v-col cols="12">
        <TopListCard title="Top Referrers" totalTitle="Total referral shares" :list="topReferrersList" color="#E28413" :total="totalRShares" unit="rSHRS"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import NumberCard from "@/components/widgets/NumberCard.vue";
  import TopListCard from "@/components/widgets/TopListCard.vue";

  import {
    mapState
  } from 'vuex';


  export default {
    name: "TopLists",
    components: {
      NumberCard,
      TopListCard,
    },
    data() {
      return {
        value1: 0,
        value2: 0,
        value3: 0,
        value4: 0,
        secondline1: 0,
        secondline2: 0,
        help1: "Uniswap liquidity not included",
        help2: "",
        help3: "",
        help4: "",
        topHoldersList: [],
        topStakersList: [],
        topShareHoldersList: [],
        topReferrersList: [],
      }
    },
    mounted() {
      this.createTopHoldersList();
      this.createTopStakersList();
      this.createTopShareHoldersList();
      this.createTopReferrersList();
      this.updateAllCards();
    },
    computed: {
      totalLiquid() {
        return this.$store.state.totalSupply - this.$store.state.uniswapBalance;
      },
      totalStaked() {
        return this.$store.state.totalStaked;
      },
      totalShares() {
        return this.$store.state.totalShares;
      },
      totalRShares() {
        return this.$store.state.referralShares;
      },
      topHolder() {
        if(this.topHoldersList.length == 0) return 0;
        return this.topHoldersList[0].value
      },
      topStaker() {
        if(this.topStakersList.length == 0) return 0;
        return this.topStakersList[0].value
      },
      topShareHolder() {
        if(this.topShareHoldersList.length == 0) return 0;
        return this.topShareHoldersList[0].value
      },
      topReferrer() {
        if(this.topReferrersList.length == 0) return 0;
        return this.topReferrersList[0].value
      },
      ...mapState({
        topHolders: state => state.topHolders,
        topStakers: state => state.topStakers,
        topShareHolders: state => state.topShareHolders,
        topReferrers: state => state.topReferrers,
      }),
    },
    methods: {
      createTopHoldersList() {
        let topHoldersList = [];
        let topHolders = this.$store.state.topHolders;
        for (let holder of topHolders) {
          topHoldersList.push({
            name: this.shortenedAccount(holder.address),
            // value: this.$options.filters.toInt(holder.staked, 0, "WISE")
            value: holder.staked
          });
        }
        this.topHoldersList = topHoldersList;
      },
      createTopStakersList() {
        let topStakersList = [];
        let topStakers = this.$store.state.topStakers;
        for (let staker of topStakers) {
          topStakersList.push({
            name: this.shortenedAccount(staker.address),
            value: staker.staked
          });
        }
        this.topStakersList =  topStakersList;
      },
      createTopShareHoldersList() {
        let topShareHoldersList = [];
        let topShareHolders = this.$store.state.topShareHolders;
        for (let shareHolder of topShareHolders) {
          topShareHoldersList.push({
            name: this.shortenedAccount(shareHolder.address),
            value: shareHolder.shares
          });
        }
        this.topShareHoldersList =  topShareHoldersList;
      },
      createTopReferrersList() {
        let topReferrersList = [];
        let topReferrers = this.$store.state.topReferrers;
        for (let referrer of topReferrers) {
          topReferrersList.push({
            name: this.shortenedAccount(referrer.address),
            value: referrer.rShares
          });
        }
        this.topReferrersList =  topReferrersList;
      },
      updateAllCards() {
        this.updateCard1();
        this.updateCard2();
        this.updateCard3();
        this.updateCard4();
      },
      isDataFetchedCard1() {
        return (
          this.$store.state.currentWiseDay > -1
        )
      },
      isDataFetchedCard2() {
        return (
          this.$store.state.currentWiseDay > -1
        )
      },
      isDataFetchedCard3() {
        return (
          this.$store.state.currentWiseDay > -1
        )
      },
      isDataFetchedCard4() {
        return (
          this.$store.state.currentWiseDay > -1
        )
      },
      updateCard1() {
        if (this.isDataFetchedCard1()) {
          this.value1 = 0;
        }
      },
      updateCard2() {
        if (this.isDataFetchedCard2()) {
          this.value2 = 0;
        }
      },
      updateCard3() {
        if (this.isDataFetchedCard3()) {
          this.value3 = 0;
        }
      },
      updateCard4() {
        if (this.isDataFetchedCard4()) {
          this.value4 = 0;
        }
      },
      shortenedAccount(address) {
        return address.slice(0, 6) + "...." + address.slice(-4);
      },
    },
    watch: {
      currenctWiseDay() {
        this.updateCard1();
      },
      topHolders() {
        this.createTopHoldersList();
      },
      topStakers() {
        this.createTopStakersList();
      },
      topShareHolders() {
        this.createTopShareHoldersList();
      },
      topReferrers() {
        this.createTopReferrersList();
      },
    }
  }
</script>

<style lang="css" scoped>
</style>
